import { Tracker } from 'gaw';

export const createTracker = (id?: string) => Tracker.init({
  trackingId: 'UA-36136046-19',
  appName: 'dodo-store-frontend',
  appVersion: '4.0',
  userId: id,
});
